import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConsentForm, ConsentFormQueryParams } from '../models/consent-form.model';
import { ListResponse } from '../models/utility.model';
import { ConsentFormGateway } from '../usecases/consent-form.gateway';

@Injectable()
export class ConsentFormService extends ConsentFormGateway {
  constructor(private _http: HttpClient) {
    super();
  }

  listConsentForms(params: ConsentFormQueryParams): Observable<ListResponse<ConsentForm>> {
    return this._http.get<ListResponse<ConsentForm>>(`api/vgs/consent-forms`, { params });
  }
}
